import { Reveal } from "@/components/common/Reveal";
import { CtaPair } from "@/components/common/CtaButtons";

// Compact call-to-action band used across inner pages
export const CtaBand = ({
  title = "Looking for the best dentist in Varanasi?",
  text = "Make an informed decision about your dental health today. Book your appointment with Dr. Ankesh Seth — call or WhatsApp us now.",
}) => (
  <section data-testid="cta-band" className="bg-white">
    <div className="mx-auto max-w-[1440px] px-6 pb-24 md:px-12 md:pb-32 lg:px-20 lg:pb-40">
      <Reveal className="relative overflow-hidden rounded-[2rem] bg-brand-blue px-8 py-14 md:px-16 md:py-20">
        <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-white/10" />
        <div className="pointer-events-none absolute -bottom-20 left-10 h-72 w-72 rounded-full bg-brand-green/20" />
        <div className="relative max-w-2xl">
          <h2 className="font-display text-3xl font-semibold leading-tight text-white md:text-5xl">
            {title}
          </h2>
          <p className="mt-5 text-white/85">{text}</p>
          <div className="mt-8 [&_a:first-child]:bg-white [&_a:first-child]:text-brand-blue [&_a:first-child:hover]:bg-white/90">
            <CtaPair />
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
